import {LinkButton} from '@components/common/button/button'
import {Loading} from '@components/common/loading/loading'
import {ShowMoreContent} from '@components/statistics/stats-timeline/item/show-more'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {useTaskEventLogStore} from '../task-event-log-store'

export const ShowMore = observer(() => {
  const [state, store] = useTaskEventLogStore()
  if (!state.isEventsLeft || !Object.keys(store.events).length) {
    return null
  }

  return (
    <div className="mt-12 mb-12">
      {state.isFetching ? (
        <div className="ml-24">
          <Loading />
        </div>
      ) : (
        <LinkButton onClick={store.loadMore}>
          <ShowMoreContent />
        </LinkButton>
      )}
    </div>
  )
})
